import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataTableService } from '../../shared/services/data/data-table.service';

const endPoint = 'admin/user';
@Injectable({
  providedIn: 'root',
})
export class UsersService extends DataTableService {
  constructor(http: HttpClient) {
    super(endPoint, http);
  }

  getUser(id: string) {
    return this.get(id);
  }

  getLocation(id: string) {
    return this.get(`locations/${id}`, {
      isPaginate: false,
    });
  }

  getReview(id: string) {
    return this.get(`rating/${id}`, { isPaginate: false });
  }

  verifyUser(userID: number) {
    return this.post('verify/' + userID);
  }
  blockUser(userID: number) {
    return this.post('block/' + userID);
  }
}
